module.exports = __webpack_public_path__ + "assets/img/live16.2903cce3.png";